<div [ngClass]="cssClassName" class="table-container">
  <div class="table-wrapper" [class.loading-wrapper]="isLoading">
    @if (isLoading) {
      <div class="loading-overlay" data-testid="results-loading-indicator">
        <mat-spinner diameter="36"></mat-spinner>
        <span>{{ loadingResultsLabel }}</span>
      </div>
    }
    @if (dataSource.data?.length) {
      <div>
        <div class="grid-container">
          @for (resData of dataSource.data; track resData; let i = $index) {
            <div class="grid-item mat-elevation-z4">
              <mat-card (click)="resultClick(resData, i)">
                <mat-card-header>
                  <mat-card-title>{{ toRes(resData).term.name }}</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                  <pub-card-content [conceptId]="resData.term.conceptId" [termId]="resData.term.id"
                  [displayFields]="resData.displayFields" [imageFields]="imageFields"></pub-card-content>
                </mat-card-content>
              </mat-card>
            </div>
          }
        </div>
      </div>
    }
    @if (dataSource.data?.length && resultPaginator) {
      <mat-paginator [length]="resultPaginator.totalItems"
        [pageSize]="20"
        [pageIndex]="resultPaginator.pageIndex"
      (page)="pageChange($event)" [showFirstLastButtons]="true"></mat-paginator>
    }
  </div>
  @if (hasNoResults()) {
    <div data-testid="no-results-message">Could not find any results@if (getSearchTerm()?.length) {
      <span
      > for "{{ getSearchTerm() }}"</span>
    }</div>
  }
</div>
